import { DataType } from 'src/app/common/models/enums/common.enum';
import { ReportTableColumn } from '../../../../models/reports.model';
import { HouseVillaPropertyDetailMenuEnum } from './housevilla-property-detail.enum';
export class HouseVillaPropertyDetailConstant {
  static overViewMenu = [
    {
      label: 'reports.overview',
      name: HouseVillaPropertyDetailMenuEnum.overview,
    },
    {
      label: 'reports.transactionHistory',
      name: HouseVillaPropertyDetailMenuEnum.transactionHistory,
    }
  ];
}
